/**
 * The names of the global variables that the core or studio bundle
 * use to store their references.
 */
export const studioBundle = '__TheatreJS_StudioBundle'
export const coreBundle = '__TheatreJS_CoreBundle'
